import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import Panel from "../components/Panel";
import KpiCard from "../components/KpiCard";
import { fmtINR } from "../lib/format";

const MOV_COLOR = { "Fast": "#4af6c3", "Medium": "#fb8b1e", "Slow": "#ff433d", "Dead": "#ff433d" };
const ABC_COLOR = { "A": "#4af6c3", "B": "#fb8b1e", "C": "#8892B0" };

export default function Inventory() {
    const [data, setData] = useState(null);
    useEffect(() => { api.get("/inventory").then((r) => setData(r.data)); }, []);
    if (!data) return <div className="font-mono-fin text-sm text-[var(--text-secondary)]">// LOADING INVENTORY...</div>;

    return (
        <div className="space-y-4">
            <div>
                <div className="font-mono-fin text-[10px] uppercase tracking-[0.25em] text-[var(--brand-amber)] mb-1">// INVENTORY & STORES</div>
                <h1 className="font-display font-black text-3xl">Material Stock Position</h1>
            </div>

            <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
                <KpiCard testId="inv-total" label="Total Value" value={data.summary.total_value} sub={`${data.items.length} SKUs`} accent />
                <KpiCard testId="inv-dead" label="Dead Stock" value={data.summary.dead_value} sub="Write-off risk" />
                <KpiCard testId="inv-slow" label="Slow Moving" value={data.summary.slow_value} sub="Liquidate" />
                <KpiCard testId="inv-abc-a" label="Class A (High Value)" value={data.summary.abc.A} sub="Focus attention" />
            </div>

            <Panel testId="inv-items" title="Stock Register" subtitle={`${data.items.length} items · By value`}>
                <div className="overflow-x-auto">
                    <table className="w-full font-mono-fin text-xs">
                        <thead className="border-b border-panel">
                            <tr className="text-[10px] uppercase tracking-wider text-[var(--text-secondary)]">
                                <th className="text-left py-2">Item</th>
                                <th className="text-left">ABC</th>
                                <th className="text-left">Movement</th>
                                <th className="text-right">Stock</th>
                                <th className="text-right">Rate</th>
                                <th className="text-right">Value</th>
                                <th className="text-right">Aging</th>
                            </tr>
                        </thead>
                        <tbody>
                            {data.items.sort((a, b) => b.value - a.value).map((i) => (
                                <tr key={i.id} className="border-b border-[var(--border)]/50 hover:bg-[var(--bg-panel-hover)]">
                                    <td className="py-2 text-[var(--text-primary)]">{i.item}</td>
                                    <td><span className="text-[10px] uppercase tracking-wider px-1.5 py-0.5 border" style={{ borderColor: ABC_COLOR[i.abc], color: ABC_COLOR[i.abc] }}>{i.abc}</span></td>
                                    <td><span className="text-[10px] uppercase tracking-wider px-1.5 py-0.5 border" style={{ borderColor: MOV_COLOR[i.movement], color: MOV_COLOR[i.movement] }}>{i.movement}</span></td>
                                    <td className="text-right text-[var(--text-primary)]">{i.stock.toLocaleString("en-IN")} <span className="text-[var(--text-muted)] text-[10px]">{i.unit}</span></td>
                                    <td className="text-right text-[var(--text-secondary)]">₹{i.rate.toLocaleString("en-IN")}</td>
                                    <td className="text-right text-amber">{fmtINR(i.value)}</td>
                                    <td className={`text-right ${i.aging_days > 90 ? "text-neg" : "text-[var(--text-secondary)]"}`}>{i.aging_days}d</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </Panel>
        </div>
    );
}
